const KEY = "compass_ref";

export function captureRefFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("ref");
    if (ref) {
      localStorage.setItem(KEY, ref.slice(0, 80));
    }
  } catch {
    /* no-op */
  }
}

export function getRef() {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function buildShareUrl(source = "signup-share") {
  const origin = typeof window !== "undefined" ? window.location.origin : "";
  return `${origin}/?ref=${encodeURIComponent(source)}`;
}

export function buildWhatsAppShareLink(source = "signup-share") {
  const url = buildShareUrl(source);
  const message =
    "I just signed up for Fourdays — they match you into small groups of 4–5 travellers around the plans you actually want to do. Goa launch coming soon. Sign up here: " +
    url;
  return `https://wa.me/?text=${encodeURIComponent(message)}`;
}
